import React from 'react';
import { MoThemeProvider } from './mo-gel';
import { HomePage } from './pages/Home/Home.page';
import { RootStyle, StyledApp } from './App.styled';
import { BreakingTheIce } from './themes/BreakingTheIce.theme';
import { Header } from './components/Header/Header';
import { Routes, Route } from 'react-router-dom';
import { AboutPage } from './pages/About';
import { ParentPage } from './pages/About/Parent/Parent.page';
import { AthletePage } from './pages/About/Athlete/Athlete.page';
import { CoachPage } from './pages/About/Coach/Coach.page';
import { GetHelpPage } from './pages/GetHelp/GetHelp.page';
import { ResearchPage } from './pages/Research/Research.page';
import { ContactUsPage } from './pages/ContactUs/ContactUs.page';
import { PrivacyPage } from './pages/Privacy/PrivacyPage';
import { Footer } from './components/Footer/Footer';
import { FaqPage } from './pages/Faq/Faq.page';
import { TermsConditionsPage } from './pages/TermsConditions/TermsConditionsPage';
import { PartnerList } from './components/Partners/PartnerList';
import { Carousel } from './components/Partners/Carousel/Carousel';

const App: React.FC = () => {
  return (
    <MoThemeProvider theme={BreakingTheIce}>
      <StyledApp>
        <RootStyle />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/whositfor/parent" element={<ParentPage />} />
          <Route path="/whositfor/athlete" element={<AthletePage />} />
          <Route path="/whositfor/coach" element={<CoachPage />} />
          <Route path="/gethelp" element={<GetHelpPage />} />
          <Route path="/research" element={<ResearchPage />} />
          <Route path="/signup" element={<ContactUsPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsConditionsPage />} />
        </Routes>
        <PartnerList />
        <Carousel />
        <Footer />
      </StyledApp>
    </MoThemeProvider>
  );
};

export default App;
